import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";

import LoggedInNav from "../layout/IME/LoggedInNav";
import LoggedOutNav from "../layout/IME/LoggedOutNav";
import OnlineUsers from "../layout/IME/OnlineUsers";
import RecommendedUsers from "../layout/IME/RecommendedUsers";
import TwoFARequest from "../layout/Innovators/TwoFARequest";

import JobMiniStream from "../layout/Employers/JobMiniStream";
// import MentorMiniStream from "../layout/Mentors/MentorMiniStream";
import MiniDiscussionStream from "../layout/Innovators/MiniDiscussionStream";
import DiscussionOfDay from "../layout/Innovators/DiscussionOfDay";

const LiveOnIME = ({
  auth: { user, channelid, jobtitle, location, verified },
  isAuthenticated,
}) => {
  const [view, setView] = useState({
    jobs: true,
    mentors: false,
    discussions: false,
  });
  const [showAuthentication, setShowAuthentication] = useState(true);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {verified && !isAuthenticated && (
        <TwoFARequest
          setShowAuthentication={setShowAuthentication}
          channelid={channelid}
          jobtitle={jobtitle}
          location={location}
        />
      )}
      {isAuthenticated && <LoggedInNav />}
      {!isAuthenticated && <LoggedOutNav />}
      <div className="flex-all-content">
        <div className="side-container border-right grey">
          {!isAuthenticated && <RecommendedUsers />}
          {isAuthenticated && <OnlineUsers />}
        </div>
        <div className="container-width">
          <div className="active-view">
            <div
              onClick={() =>
                setView({ jobs: true, mentors: false, discussions: false })
              }
              className="section-title blue"
            >
              ime Jobs
              {view.jobs && <i className="far fa-check-circle mx-5 blue"></i>}
            </div>
            <div
              onClick={() =>
                setView({ jobs: false, mentors: true, discussions: false })
              }
              className="section-title red"
            >
              ime Mentors
              {view.mentors && <i className="far fa-check-circle mx-5 red"></i>}
            </div>
            <div
              onClick={() =>
                setView({ jobs: false, mentors: false, discussions: true })
              }
              className="section-title green"
            >
              ime Discussions
              {view.discussions && (
                <i className="far fa-check-circle mx-5 green"></i>
              )}
            </div>
          </div>
          <div className="page-content">
            {view.jobs && (
              <div>
                <section className="banner-hero blue">
                  <div className="banner-section-name">
                    <h1 className="large-font white">Live on ime Jobs</h1>
                    <div className="post-action-button">
                      <Link to="/liveonime/employers">
                        <div className="banner-action-items blue">
                          <div className="banner-action-button">
                            <i className="fas fa-chart-line action-icon-banner"></i>
                          </div>
                          <p className="banner-action-text">
                            Trending
                            <span className="banner-section-info blue">
                              View All{" "}
                              <i className="fas fa-arrow-right fa-sm mx-5 blue"></i>
                            </span>
                          </p>
                        </div>
                      </Link>
                      {user && user.role === "employer" && (
                        <Link
                          to={`/liveonime/employers/${user.channelid}/live`}
                        >
                          <div className="banner-action-items blue">
                            <div className="banner-action-button">
                              <i className="fas fa-video action-icon-banner"></i>
                            </div>
                            <p className="banner-action-text">Go Live</p>
                          </div>
                        </Link>
                      )}
                    </div>
                  </div>
                </section>
                <section className="main-body">
                  <div className="created-content">
                    <div className="content-container">
                      <div className="stream-result">
                        <JobMiniStream />
                      </div>
                    </div>
                    <div className="content-container">
                      <div className="stream-result">
                        <JobMiniStream />
                      </div>
                    </div>
                    <div className="content-container">
                      <div className="stream-result">
                        <JobMiniStream />
                      </div>
                    </div>
                    <div className="content-container">
                      <div className="stream-result">
                        <JobMiniStream />
                      </div>
                    </div>
                    <div className="content-container">
                      <div className="stream-result">
                        <JobMiniStream />
                      </div>
                    </div>
                    <div className="content-container">
                      <div className="stream-result">
                        <JobMiniStream />
                      </div>
                    </div>
                    <div className="content-container">
                      <div className="stream-result">
                        <JobMiniStream />
                      </div>
                    </div>
                    <div className="content-container">
                      <div className="stream-result">
                        <JobMiniStream />
                      </div>
                    </div>
                    <div className="content-container">
                      <div className="stream-result">
                        <JobMiniStream />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            )}
            {view.mentors && (
              <div>
                <section className="banner-hero red">
                  <div className="banner-section-name">
                    <h1 className="large-font white">Live on ime Mentors</h1>
                    <div className="post-action-button">
                      <Link to="/liveonime/mentors">
                        <div className="banner-action-items red">
                          <div className="banner-action-button">
                            <i className="fas fa-chart-line action-icon-banner"></i>
                          </div>
                          <p className="banner-action-text">
                            Trending
                            <span className="banner-section-info red">
                              View All{" "}
                              <i className="fas fa-arrow-right fa-sm mx-5 red"></i>
                            </span>
                          </p>
                        </div>
                      </Link>
                      {user && user.role === "mentor" && (
                        <Link to={`/liveonime/mentors/${user.channelid}/live`}>
                          <div className="banner-action-items red">
                            <div className="banner-action-button">
                              <i className="fas fa-video action-icon-banner"></i>
                            </div>
                            <p className="banner-action-text">Go Live</p>
                          </div>
                        </Link>
                      )}
                    </div>
                  </div>
                </section>
                <section className="main-body">
                  <div className="created-content">
                    {/* <Link to="/liveonime/mentors/stream_id">
                    <MentorMiniStream />
                  </Link>
                  <Link to="/liveonime/mentors/stream_id">
                    <MentorMiniStream />
                  </Link>
                  <Link to="/liveonime/mentors/stream_id">
                    <MentorMiniStream />
                  </Link>
                  <Link to="/liveonime/mentors/course_stream_id">
                    <MentorMiniStream />
                  </Link>
                  <Link to="/liveonime/mentors/course_stream_id">
                    <MentorMiniStream />
                  </Link>
                  <Link to="/liveonime/mentors/course_stream_id">
                    <MentorMiniStream />
                  </Link>
                  <Link to="/liveonime/mentors/course_stream_id">
                    <MentorMiniStream />
                  </Link>
                  <Link to="/liveonime/mentors/course_stream_id">
                    <MentorMiniStream />
                  </Link>
                  <Link to="/liveonime/mentors/course_stream_id">
                    <MentorMiniStream />
                  </Link> */}
                  </div>
                </section>
              </div>
            )}
            {view.discussions && (
              <div>
                <div className="discussion-topic-hero">
                  <DiscussionOfDay />
                </div>
                <section className="main-body">
                  <div className="created-content">
                    <Link to="liveonime/discussions/imediscussion">
                      <div className="content-container">
                        <div className="stream-result">
                          <div className="stream-video">
                            <div className="video-overlay">
                              <div className="stream-live green">
                                <i className="fas fa-circle mx-5"></i>
                                Live
                              </div>
                              <div className="stream-viewers white">
                                <i className="fas fa-user mx-5"></i>
                                92.2k
                              </div>
                              <div className="stream-type">1-on-1</div>
                            </div>
                            <video
                              className="radius fill-video"
                              src={
                                "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/20190628_140936.mp4"
                              }
                            ></video>
                          </div>
                        </div>
                      </div>
                    </Link>
                    <Link to="liveonime/discussions/imediscussion">
                      <div className="content-container">
                        <div className="stream-result">
                          <div className="stream-video">
                            <div className="video-overlay">
                              <div className="stream-live green">
                                <i className="fas fa-circle mx-5"></i>
                                Live
                              </div>
                              <div className="stream-viewers white">
                                <i className="fas fa-user mx-5"></i>
                                92.2k
                              </div>
                              <div className="stream-type">Panel</div>
                            </div>
                            <video
                              className="radius fill-video"
                              src={
                                "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/discussion_two.mp4"
                              }
                            ></video>
                          </div>
                        </div>
                      </div>
                    </Link>
                    <Link to="liveonime/discussions/imediscussion">
                      <div className="content-container">
                        <div className="stream-result">
                          <div className="stream-video">
                            <div className="video-overlay">
                              <div className="stream-live green">
                                <i className="fas fa-circle mx-5"></i>
                                Live
                              </div>
                              <div className="stream-viewers white">
                                <i className="fas fa-user mx-5"></i>
                                92.2k
                              </div>
                              <div className="stream-type">Group</div>
                            </div>
                            <video
                              className="radius fill-video"
                              src={
                                "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/discuss.mp4"
                              }
                            ></video>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                </section>
                <section className="banner-hero green">
                  <div className="banner-section-name">
                    <h1 className="large-font white">
                      Live on ime Discussions
                    </h1>
                    <div className="post-action-button">
                      <Link to="/liveonime/innovators">
                        <div className="banner-action-items green">
                          <div className="banner-action-button">
                            <i className="fas fa-chart-line action-icon-banner"></i>
                          </div>
                          <p className="banner-action-text">
                            Trending
                            <span className="banner-section-info green">
                              View All{" "}
                              <i className="fas fa-arrow-right fa-sm mx-5 green"></i>
                            </span>
                          </p>
                        </div>
                      </Link>
                      {user && user.role === "innovator" && (
                        <Link to={`/${user.channelid}/create_discussion`}>
                          <div className="banner-action-items green">
                            <div className="banner-action-button">
                              <i className="fas fa-video action-icon-banner"></i>
                            </div>
                            <p className="banner-action-text">Go Live</p>
                          </div>
                        </Link>
                      )}
                    </div>
                  </div>
                </section>
                <section className="main-body">
                  <div className="created-content">
                    <div className="content-container">
                      <div className="stream-result">
                        <MiniDiscussionStream />
                      </div>
                    </div>
                    <div className="content-container">
                      <div className="stream-result">
                        <MiniDiscussionStream />
                      </div>
                    </div>
                    <div className="content-container">
                      <div className="stream-result">
                        <MiniDiscussionStream />
                      </div>
                    </div>
                    <div className="content-container">
                      <div className="stream-result">
                        <MiniDiscussionStream />
                      </div>
                    </div>
                    <div className="content-container">
                      <div className="stream-result">
                        <MiniDiscussionStream />
                      </div>
                    </div>
                    <div className="content-container">
                      <div className="stream-result">
                        <MiniDiscussionStream />
                      </div>
                    </div>
                    <div className="content-container">
                      <div className="stream-result">
                        <MiniDiscussionStream />
                      </div>
                    </div>
                    <div className="content-container">
                      <div className="stream-result">
                        <MiniDiscussionStream />
                      </div>
                    </div>
                    <div className="content-container">
                      <div className="stream-result">
                        <MiniDiscussionStream />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            )}
            <div className="margin-top"></div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

LiveOnIME.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(LiveOnIME);
